const request = {
    invalid_input: 'Eingabe ist ungültig. {{details}}',
    general: 'Es ist ein Fehler bei der Anfrage aufgetreten.',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
    /** UNTRANSLATED */
    too_many_requests: 'Too many requests.',
};
export default Object.freeze(request);
